var LocalizeDataAttributes;
!function (a) {
  a.name = "data-var", a.pluralize = "data-pluralize", a.count = "data-count", a.ignore = "data-ignore", a.disabled = "disabled";
}(LocalizeDataAttributes || (LocalizeDataAttributes = {}));
export { LocalizeDataAttributes };